export default "__VITE_ASSET__zXrDLiUx__"